import { createFeature, createReducer, on } from '@ngrx/store';
import { ContactDetailsActions } from '../../actions/contact-details/contact-details.actions';
import { OrganizationContact } from '@models/organizationContact.model';
import { AddOrganizationActions } from '@store/actions/add-organization/add-organization.actions';


export const contactDetailsFeatureKey = 'contactDetails';



export interface State {
  contacts: OrganizationContact[],
  search: string,
  page: number,
  itemsPerPage: number,
  totalItems: number,
  isContactSaveDisabled: boolean
}

export const initialState: State = {
  contacts: [],
  search: "",
  page: 0,
  itemsPerPage: 5,
  totalItems: 0,
  isContactSaveDisabled: false,
};

export const reducer = createReducer(
  initialState,

  on(ContactDetailsActions.addContactSave, (state, action) => ({
    ...state,
    isContactSaveDisabled: true
  })),
  on(ContactDetailsActions.contactSavedSuccess, (state, action) => ({
    ...state,
    contacts: [...state.contacts, action.data],
    isContactSaveDisabled: false
  })),
  on(ContactDetailsActions.contactSavedFailure, (state, action) => ({
    ...state,
    isContactSaveDisabled: false
  })),

  on(ContactDetailsActions.editContact, (state, action) => ({
    ...state,
    isContactSaveDisabled: true
  })),

  on(ContactDetailsActions.editContactFailure, (state, action) => ({
    ...state,
    isContactSaveDisabled: false
  })),
  on(ContactDetailsActions.editContactSuccess, (state, action) => {
    const updatedContacts = state.contacts.map((contact) =>
      action.data.id === contact.id ? action.data : contact
    );
    return {
      ...state,
      contacts: updatedContacts,
      isContactSaveDisabled: false
    };
  }),
  on(ContactDetailsActions.deleteContactSuccess, (state, action) => {
    const updatedContacts = state.contacts.filter((contact) => contact.id != action.id );
    return {
      ...state,
      contacts: updatedContacts,
    };
  }),
  on(AddOrganizationActions.getOrganizationDetailsSuccess, (state, action) => ({
    ...state,
    contacts: action.details.organizationContacts,
    totalItems: action.details.organizationContacts.length
  })),
  on(ContactDetailsActions.itemsPerPageChanged, (state, action) => ({
    ...state,
    itemsPerPage: action.items
  })),

  on(ContactDetailsActions.pageNumberChanged, (state, action) => ({
    ...state,
    page: action.page
  })),

);

export const contactDetailsFeature = createFeature({
  name: contactDetailsFeatureKey,
  reducer,
});

